import { render, staticRenderFns } from "./IsNewTabs.vue?vue&type=template&id=65e2ace8"
import script from "./IsNewTabs.vue?vue&type=script&lang=ts"
export * from "./IsNewTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports